"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MetricsApiConnector = /** @class */ (function () {
    function MetricsApiConnector() {
    }
    MetricsApiConnector.getGlobal = function () {
        if (typeof window !== 'undefined') {
            return window;
        }
        if (typeof global !== 'undefined') {
            return global;
        }
        throw new Error('unable to locate global object');
    };
    MetricsApiConnector.setWindow = function (win) {
        this.win = win;
    };
    MetricsApiConnector.setScreenviewConfig = function (data) {
        return this.dispatchEvent('setScreenviewConfig', { data: data });
    };
    MetricsApiConnector.trackScreenview = function (data) {
        return this.dispatchEvent('trackScreenview', { data: data });
    };
    MetricsApiConnector.trackEvent = function (event, data) {
        return this.dispatchEvent('trackEvent', { event: event, data: data });
    };
    MetricsApiConnector.trackSimpleEvent = function (name) {
        return this.dispatchEvent('trackSimpleEvent', name);
    };
    MetricsApiConnector.trackServiceReady = function (service, data) {
        return this.dispatchEvent('trackServiceReady', { service: service, data: data });
    };
    MetricsApiConnector.dispatchEvent = function (name, data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (typeof window === 'undefined') {
                var msg = 'MetricsApiConnector > rejected "window is not defined"';
                return reject(msg);
            }
            if (_this.env !== 'prod') {
                if (!_this.logged) {
                    console.log("The MetricsApiConnector will log your request as its environment is: \"".concat(_this.env, "\""));
                    _this.logged = true;
                }
                var objJson = JSON.stringify(data);
                var cleanObj = JSON.parse(objJson, function (key, value) {
                    if (typeof value === 'string') {
                        return value.replace(/&amp;/g, '&');
                    }
                    return value;
                });
                console.log("MetricsApiConnector.".concat(name), cleanObj);
            }
            try {
                _this.win.document.dispatchEvent(new CustomEvent("metricsApi.".concat(name), { detail: data }));
                // @ts-ignore
                if (_this.win.metricsApiEnabled) {
                    return resolve();
                }
            }
            catch (e) {
                return reject(e);
            }
            reject('metricsApi is not enabled');
        });
    };
    var _a, _b, _c;
    var _d;
    _d = MetricsApiConnector;
    MetricsApiConnector.win = _d.getGlobal();
    // @ts-ignore
    MetricsApiConnector.env = ((_c = (_b = (_a = _d.win.metricsApi) === null || _a === void 0 ? void 0 : _a.defaultData) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.environment) || 'unknown';
    return MetricsApiConnector;
}());
exports.default = MetricsApiConnector;
